// extracted by mini-css-extract-plugin
export default {"form":"RegisterForm_form__MXcIV","label":"RegisterForm_label__otkSq","input":"RegisterForm_input__nAzwd","button":"RegisterForm_button__IvNp2"};